import React, { useState, useRef, useEffect, useMemo } from "react";
import { SimpleSingleSelect } from "../../components/FormComponents/SimpleSingleSelect";
import { DateRangePicker } from "react-date-range";
import { addMonths, endOfDay, startOfDay } from "date-fns";
import format from "date-fns/format";
import { CTA } from "@coverme/forms";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "./DataHolder.scss";
import { isNullOrWhitespace } from "../../services/stringService";
import { noop } from "lodash-es";
import { defaultStaticRanges } from "./defaultRanges";

export const ReportingFilter = ({
    formattedFacilities,
    submitFilter,
    selectedCustomerChanged,
    selectedCustomer,
    exportEncounters,
}) => {
    const [facilityName, setFacilityName] = useState(selectedCustomer);
    const [canOpenDateRangePickerCalendar, setCanOpenDateRangePickerCalendar] = useState(false);
    const [isEndDateSet, setIsEndDateSet] = useState(true);


    const [selectionRange, setSelectionRange] = useState([
        {
            startDate: startOfDay(addMonths(new Date(), -1)),
            endDate: endOfDay(new Date()),
            key: "selection",
        },
    ]);
    const refOnce = useRef(null);
    const facilityOptions = useMemo(() => {
        let facilities = [...formattedFacilities];
        return facilities.map(x => ({ label: x.label, value: x.value }));
    }, [formattedFacilities]);

    const handleOutsideClick = event => {
        if (refOnce.current && !refOnce.current.contains(event.target)) {
            setCanOpenDateRangePickerCalendar(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleOutsideClick);

        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);

    const customRanges = [
        {
            label: "Last 7 days",
            value: {
                startDate: new Date(new Date().setDate(new Date().getDate() - 6)),
                endDate: new Date(),
            },
        },
        {
            label: "Last 30 days",
            value: {
                startDate: new Date(new Date().setDate(new Date().getDate() - 29)),
                endDate: new Date(),
            },
        },
        // Add more custom ranges as needed
    ];

    useEffect(() => {
        if (!isNullOrWhitespace(facilityName) && (isEndDateSet == true || selectionRange[0].startDate != selectionRange[0].endDate)) {
            submitFilter({
                customerIds: [facilityName],
                startDate: selectionRange[0].startDate,
                endDate: selectionRange[0].endDate,
            });
            selectedCustomerChanged({
                facilityName: facilityName,
                startDate: selectionRange[0].startDate,
                endDate: selectionRange[0].endDate,
            });
        }
    }, [facilityName, selectionRange]);
    return (
        <div className="filter-switch reporting-filter-button">
            {/* Date Range Component */}
            <div className="facility_div_width_with_margin">
                <div className={"facility_label_text"}>
                    <label>Facility</label>
                </div>
                <SimpleSingleSelect
                    className="facility_combo_box"
                    id="facility-id"
                    options={facilityOptions}
                    setFieldValue={(event, value) => {
                        setFacilityName(value);
                    }}
                    onChange={facilityOptions =>
                        setFacilityName(facilityOptions ? facilityOptions.map(option => option) : [])
                    }
                    value={facilityName}
                    setFieldTouched={noop}
                />
            </div>

            {/* Date Range Component */}
            <div className="facility_date_export_grid_date_column">
                <div className={"date_label_text"}>Date</div>
                <div className="calendar_wrap">
                    <input
                        value={
                            selectionRange
                                ? `${format(selectionRange[0].startDate, "MM/dd/yyyy")} To ${format(
                                      selectionRange[0].endDate,
                                      "MM/dd/yyyy"
                                  )}`
                                : ""
                        }
                        readOnly
                        onClick={() =>{
                            setIsEndDateSet(true)
                            setCanOpenDateRangePickerCalendar(
                                canOpenDateRangePickerCalendar => !canOpenDateRangePickerCalendar
                            )
                        }}
                        className="input_box"
                    />

                    <div ref={refOnce}>
                        {canOpenDateRangePickerCalendar && (
                            <DateRangePicker
                                onChange={item => {
                                    item.selection.endDate = endOfDay(item.selection.endDate);
                                    setIsEndDateSet(!isEndDateSet)
                                    setSelectionRange([item.selection]);
                                }}
                                showSelectionPreview={true}
                                moveRangeOnFirstSelection={false}
                                id="date-range-picker-id"
                                ranges={selectionRange}
                                direction="horizontal"
                                months={1}
                                appearance="subtle"
                                placeholder="Subtle"
                                className={"date_range_picker_calendar_pop_up"}
                                staticRanges={defaultStaticRanges}
                                inputRanges={[]}
                            />
                        )}
                    </div>
                </div>
            </div>

            {/* Export Button */}
            <div className={"export_button_div"}>
                <div className={"export_report_button"}>
                    <CTA size={"medium"} styleType={"grey-dark"} click={exportEncounters}>
                        Export
                    </CTA>
                </div>
            </div>
        </div>
    );
};
